{
  "title": "La nueva forma de convertirse en emprendedor",
  "subTitle": "Impulsa tus habilidades innovadoras",
  "logBackIn": "Iniciar sesión",
  "or": "o",
  "logOut": "Cerrar sesión",
  "signUpFree": "Regístrate gratis",
  "video": "Video",
  "entrepreneurship": "Emprendimiento",
  "entrepreneurshipSubTitle": "Simplificado en tres pasos.",
  "build": "Construir",
  "buildSubTitle": "Lanza tu empresa desde cero",
  "buildDescription": "Pon en marcha tu empresa o llévala al siguiente nivel con módulos guiados que desarrollarán tus habilidades.",
  "showcase": "Escaparate",
  "showcaseSubTitle": "Genera interacción temprana + interés",
  "showcaseDescription": "Muestra tus logros en el perfil de tu proyecto y llama la atención de talentos, patrocinadores y personas que te impulsarán a lograr el objetivo.",
  "connect": "Conectar",
  "connectSubTitle": "Une fuerzas con otros para incrementar tu crecimiento",
  "connectDescription": "Participa en eventos y comunidades online y conoce a socios con habilidades para acelerar tu empresa.",
  "launchTitle": "CREA UN MUNDO DIFERENTE.",
  "launchSubTitle1": "El espíritu empresarial puede tener un ritmo vertiginoso.",
  "launchSubTitle2": "Así es como te acompañaremos:",
  "launchText1Part1": "Un ",
  "launchText1Part2": "espacio de trabajo compartido online",
  "launchText1Part3": " para facilitar la colaboración con tu equipo",
  "launchText2Part1": "Talleres interactivos",
  "launchText2Part2": " que te llevan a descubrir respuestas a las preguntas adecuadas",
  "launchText3Part1": "Ajustable ",
  "launchText3Part2": "ajustes de privacidad",
  "launchText3Part3": " para que puedas controlar quien ve tu proyecto y quien no",
  "launchText4Part1": "Acceso a ",
  "launchText4Part2": "competiciones",
  "launchText4Part3": ", online y presenciales, para poner a prueba la validez de tu empresa",
  "launchText5Part1": "Premios y puntos",
  "launchText5Part2": " que permiten a otros usuarios mostrar su apoyo",
  "launchText6Part1": "Oportunidades para construir ",
  "launchText6Part2": "relaciones",
  "launchText6Part3": ", obtener recursos, reunir capital y ser reclutado",
  "buildersTitle": "Descubre un Campo de Pruebas para los No Convencionales",
  "buildersSubTitle": "Elige píldoras formativas (como estas) para fortalecer tus poderes innovadores y crear un perfil de tu proyecto.",
  "builder1Title": "Problema",
  "builder1Question": "¿Qué necesidad vas a satisfacer?",
  "builder2Title": "Equipo central",
  "builder2Question": "¿Con quién trabajarás para lanzar la solución y cómo colaboraréis?",
  "builder3Title": "Prototesting",
  "builder3Question": "¿Cómo puedes hacer una demostración, probar y mejorar tu solución?",
  "builder4Title": "Entorno competitivo",
  "builder4Question": "¿Quiénes son tus competidores y cómo te distingues o cambias el juego?",
  "signUpExploreLink": "Regístrate gratis + explora nuestros builders",
  "joinTitle": "Únete a una comunidad de rebels. Lleva tu solución al siguiente nivel.",
  "getStarted": "Empieza",
  "hubTitlePart1": "¿Quieres un HUB para ",
  "hubTitlePart2": "tus",
  "hubTitlePart3": " innovadores?",
  "hubSubTitle": "Organiza eventos, equipa a innovadores y construye una comunidad con el objetivo de cambiar el mundo.",
  "hubRequestLink": "Solicita una invitación para iniciar tu hub",
  "ClickHereToUpdateYourBrowser": "Haz clic aquí para actualizar tu navegador.",
  "OutdatedBrowserMessage": "Tu navegador está un poco desactualizado para este sitio web.",
  "BuilderTitle": "Título del Builder",
  "ViewBuilder": "Vista del builder",
  "DueDate": "Fecha de vencimiento (opcional)",
  "PlaygroundTitlePart1": "ideación",
  "PlaygroundTitlePart2": "¡Únete a nosotros el 6/1!",
  "PlaygroundPhrase": "Piense en ideas que cambien el juego y decide una que puedas hacer realidad. Las ideas destacadas tendrán la oportunidad de ganar premios.",
  "AddBuilders": "Agregar builders",
  "close": "Cerrar",
  "firstName": "Nombre",
  "lastName": "Apellidos",
  "Email": "Email",
  "Password": "Contraseña",
  "ConfirmPassword": "Confirmar contraseña",
  "PrivacyPolicy": "política de privacidad",
  "SignUpConsent1Part1": "Doy mi consentimiento para el uso de cookies. RebelBase utiliza cookies para mantener las preferencias del usuario y mejorar la experiencia del usuario. ",
  "SignUpConsent1Part2": "Para obtener detalles sobre cómo protegemos sus datos personales, consulte nuestra ",
  "SignUpConcent2Part1": "Doy mi consentimiento para la recopilación y el procesamiento de datos por parte de RebelBase. ",
  "SignUpConcent2Part2": "RebelBase procesa datos personales para brindar servicios en la plataforma. Ver: ",
  "SignUpConcent3Part1": "Doy mi consentimiento para la transmisión de datos a los Estados Unidos. RebelBase es una empresa estadounidense. ",
  "SignUpConcent3Part2": "Para brindarle servicios, transferiremos de forma segura datos personales a los Estados Unidos. Ver: ",
  "SignUpConcent4Part1": "Doy mi consentimiento para recibir actualizaciones promocionales por correo electrónico de RebelBase. ",
  "SignUpConcent4Part2": "RebelBase puede enviar a los clientes actualizaciones por correo electrónico para pedirles su opinión con una encuesta o comunicaciones de marketing. Puede anular su suscripción en cualquier momento. Ver: ",
  "optional": ". (Opcional)",
  "ContactUsTitle": "¿Quieres hablar?",
  "ContactUsPhrase": "¡Nosotros también! Escríbenos y avísanos sobre tus problemas, cumplidos o preguntas generales. Nos comunicaremos contigo en un plazo de 24 horas .",
  "ContactUsMessage": "¿Cómo podemos ayudarte?",
  "SubmitButton": "Enviar",
  "agree": "Al registrarse, acepta nuestros ",
  "terms": "términos de servicio.",
  "signedUp?": "¿Ya te has registrado? ",
  "Login": "Iniciar sesión",
  "ForgotPassword": "¿Olvidaste tu contraseña?",
  "EmailAddress": "Dirección de correo electrónico",
  "SendInstructions": "Envíame instrucciones >",
  "ResetYourPassword": "Restablecer tu contraseña",
  "ResetButton": "Reiniciar >",
  "instead": "en lugar",
  "NoAccount": "¿No tienes cuenta?",
  "Signup": "Regístrate",
  "PrivacyPolicyConsent": "Consentimiento de la política de privacidad",
  "HelloThere": "Hola a todos. ",
  "concentPagePart1": "¡Cumplimos con el RGPD! Técnicamente, siempre lo hemos hecho. Hemos protegido tu privacidad desde el principio, pero ahora, actualizamos nuestra  ",
  "and": "y",
  "concentPagePart2": "idioma para ajustarse a las regulaciones de GDPR.",
  "concentPagePart3": "Para continuar usando RebelBase, por favor acepta y consiente lo siguiente: ",
  "concent": "Al dar tu consentimiento, también acepta nuestra ",
  "concentSubmitLink": "consentimiento + enviar",
  "SearchProjects": "Buscar Proyectos",
  "Search": "Buscar",
  "createProjectButton": "Crea un Proyecto",
  "myEventsButton": "Mis Eventos",
  "ShowingAllProjects": "Mostrando todos los proyectos",
  "ShowingProjects": "Mostrando proyectos",
  "for": "para",
  "in": "en",
  "Industries": "Industrias",
  "NoMatches": "No hay coincidencias",
  "Projects": "Proyectos",
  "Admin": "Administrador",
  "Notifications": "Notificaciones",
  "Settings": "Ajustes",
  "Help": "Ayuda",
  "More": "Más",
  "ClearFilters": "Borrar filtros",
  "Menu": "Menú",
  "Home": "Menú principal",
  "Browse": "Biblioteca de proyectos",
  "5DayChallenge": "Desafío de 5 días",
  "5Day": "5 días",
  "challenge": "Desafío",
  "AboutUs": "Sobre nosotros",
  "LoadMore": "Más"
}